module.exports = __webpack_public_path__ + "img/zinly.c9487d95.jpg";